import type { TransportCostAllocationResult } from '../../utils/transportCostAllocation';

// The allocation shown on the transport card is a planning view. It is not the
// ledger that posts PZ/WZ costs. When a selected basis cannot split the whole
// truck cost, rendering the missing share as "0 PLN" is misleading.
export function hasCompleteTransportCostAllocation(
  allocation: { summary: Pick<TransportCostAllocationResult['summary'], 'allocationDifference'> },
): boolean {
  return Math.abs(Number(allocation.summary.allocationDifference) || 0) < 0.005;
}

// Save responses of POST/PUT /transport-routes carry the cost-split warnings of
// that save (backend transportService.attachAllocationWarnings; stripped for
// viewers without transport cost visibility). Returns the business numbers of
// customer orders and stock ZDs whose m²/m³/LDM basis misses product
// dimensions; empty when the response has none.
export function readMissingDimensionLabels(responseData: unknown): string[] {
  const warnings = (responseData as { allocationWarnings?: unknown } | null)?.allocationWarnings;
  if (!Array.isArray(warnings)) return [];
  return warnings
    .filter((warning) => (warning as { code?: unknown } | null)?.code === 'MISSING_DIMENSIONS')
    .map((warning) => {
      const row = warning as { label?: unknown; orderId?: unknown; supplierOrderId?: unknown };
      return String(row.label || row.orderId || row.supplierOrderId || '');
    })
    .filter(Boolean);
}
